import { useTranslation } from 'react-i18next';
import { Flex } from '@chakra-ui/react';
import format from 'date-fns/format';

import type { ApiNabanDeed } from '@izimi/api';
import { useDateLocale, useIsMobile } from '@izimi/hooks';

import { NabanCardListItem } from '../../../components/NabanCardListItem';
import { NabanDetailsListCard } from '../../../components/NabanDetailsListCard';
import { NabanDetailsListItem } from '../../../components/NabanDetailsListItem';
import { useNabanStoreSelectedAuthenticationMethod } from '../../../store';
import type { RenderDeedOptions } from '../../util/types';
import { nabanDetailsListCardContentProps } from './styles';

type Props = {
  documents: ApiNabanDeed['additions'];
  napId: string;
  renderDeedOptions?: RenderDeedOptions;
};

export const NabanDeedAdditions = ({ documents, napId, renderDeedOptions }: Props) => {
  const isMobile = useIsMobile();
  const {
    t,
    i18n: { language },
  } = useTranslation('naban');
  const locale = useDateLocale(language);

  const selectedAuthenticationMethod = useNabanStoreSelectedAuthenticationMethod();

  return (
    <NabanDetailsListCard
      title={t('deed.additionsDocuments.title')}
      contentProps={nabanDetailsListCardContentProps}>
      {documents.map((doc) => (
        <Flex key={doc.documentToken} w='full' flexDirection='column'>
          <NabanCardListItem title={doc.additionType?.label ?? ''}>
            {doc.additionText && (
              <NabanDetailsListItem
                flex={1}
                title={t('deed.additionsDocuments.label.additionText')}
                value={doc.additionText}
                display={isMobile ? 'none' : 'flex'}
                ellipsis
              />
            )}
            {doc.creationDate && (
              <NabanDetailsListItem
                flex={1}
                title={t('deed.additionsDocuments.label.additionDate')}
                value={format(new Date(doc.creationDate), 'PPP', { locale })}
                display={isMobile ? 'none' : 'flex'}
              />
            )}
            {renderDeedOptions
              ? renderDeedOptions({
                  documentToken: doc.documentToken,
                  documentTitle: doc.additionType?.label ?? '',
                  napId,
                  documentIdentifier: doc.documentIdentifier,
                  authenticationModeToken: selectedAuthenticationMethod?.token,
                  isEmbeddedDocument: false,
                })
              : null}
          </NabanCardListItem>
        </Flex>
      ))}
    </NabanDetailsListCard>
  );
};
